import { Operation } from 'shell/view-models/operation';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { Order } from 'shell/view-models/order';
import { ResearchTypeOperationVM } from 'practice/view-models/research-type-operation';

export const transformDataset = (values: ResearchTypeOperationVM): string => {
  const transformedFilters: OperationObject = {
    tipoPratica: { value: values.filter?.typePractice || '', operation: Operation.EQUALS },
    tipoOperazione: {
      value: values.filter?.code || '',
      operation: Operation.LIKE,
    },
    descrizioneTipoOperazione: {
      value: values.filter?.description || '',
      operation: Operation.LIKE,
    },
    codiceTipoDocumento: {
      value: values.filter?.typeDocument || '',
      operation: Operation.EQUALS,
    },
    flagOperazioneInUso: {
      value: values.filter?.inUse || '',
      operation: Operation.EQUALS,
    },
  };

  const ordersToTransform = values.filter?.orders || {};
  const ordersMapped: Order = {
    tipoPratica: ordersToTransform?.practice,
    descrizioneTipoOperazione: ordersToTransform?.description,
    tipoOperazione: ordersToTransform?.code,
    codiceTipoDocumento: ordersToTransform?.typeDocument,
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
  })}`;
};
